// @flow

import * as React from 'react';

import ConditionalRoute, {
  ConditionalRouteProps,
} from 'components/RouterProvider/ConditionalRoute';
import { connectOrganizationAdmin } from 'components/RouterProvider/AuthorizationRoutes/connect';
import consts from 'consts/routing';

const { DASHBOARD } = consts;

const OrganizationAdminProtectedRoute = ({
  isOrganizationAdmin,
  ...props
}: ConditionalRouteProps & { isOrganizationAdmin: boolean }) => (
  <ConditionalRoute isConditionSatisfied={isOrganizationAdmin} {...props} />
);

OrganizationAdminProtectedRoute.defaultProps = {
  config: { redirectTo: DASHBOARD },
};

export default connectOrganizationAdmin(OrganizationAdminProtectedRoute);
